const LOWERCASE_ARTICLES = new Set(['de', 'del', 'la', 'las', 'los', 'el', 'y']);

const titleCaseWord = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

const isAbbreviation = (word: string): boolean => /^([a-z]{1,4}\.)+$/i.test(word);

export const formatLocality = (input: string | undefined | null): string => {
	if (!input) return '';
	return input
		.split(',')
		.map((segment) =>
			segment
				.trim()
				.toLowerCase()
				.split(/\s+/)
				.filter(Boolean)
				.map((word, index) => {
					if (isAbbreviation(word)) {
						return word.toUpperCase();
					}
					if (index > 0 && LOWERCASE_ARTICLES.has(word)) {
						return word;
					}
					return titleCaseWord(word);
				})
				.join(' ')
		)
		.join(', ');
};
